import { render, staticRenderFns } from "./ChatOverlord.vue?vue&type=template&id=31a216f6&"
import script from "./ChatOverlord.vue?vue&type=script&lang=js&"
export * from "./ChatOverlord.vue?vue&type=script&lang=js&"
import style0 from "./ChatOverlord.vue?vue&type=style&index=0&id=31a216f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports